import { ContactForm } from '@components';
import { useKnowHowForm } from '@hooks';
import { buyerServiceUrl } from '@constants';

export const KnowHowForm: React.FC<{ category?: string }> = ({ category }) => {
  const { onSubmit, errorMessage, emailTaken } = useKnowHowForm();

  return (
    <>
      <div className='-mx-4 bg-lightgray p-4 sm:mx-0'>
        <ContactForm
          category={category}
          hideContentInput
          hideFileInput
          onSubmit={onSubmit}
        />
      </div>
      <div className='text-center'>
        {errorMessage && (
          <div className='font-bold text-red'>{errorMessage}</div>
        )}
        {emailTaken && (
          <div className='font-bold text-red'>
            発注ナビに登録済みのメールアドレスです。
            <br />
            <a
              href={buyerServiceUrl}
              target='_blank'
              rel='noopener noreferrer'
              className='text-primary hover:text-top-primary'
            >
              こちら
            </a>
            からログインしてご利用ください。
          </div>
        )}
      </div>
    </>
  );
};
